<template>
  <div>
    <mdb-card class="mb-4">
      <mdb-card-header v-if="error || carouselData.length == 0">
        Group Slideshow
      </mdb-card-header>
      <mdb-card-body>
        <div v-if="!imagesLoading && carouselData.length == 0 && group.role=='Admin'">
          The group slideshow currently has no images. You can add images from your image library
          or from event galleries.
        </div>
        <div v-if="imagesLoading" class="text-center">
          <div class="spinner-grow text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <mdb-carousel :interval="5000" :items="carouselData" controlls indicators v-if="carouselData.length > 0 "/>
        <error :error="error" v-if="error"/>
        <div class="text-center" v-if="loggedIn && carouselData.length > 0">
          <mdb-btn @click="reloadImages" rounded size="sm">Reload</mdb-btn>
          <mdb-btn @click="navGalleries" v-if="group.role != 'Public'" rounded size="sm">Galleries
          </mdb-btn>
        </div>
      </mdb-card-body>
    </mdb-card>

  </div>
</template>

<script>
import error from '../common/Error'
import api from '../../services/groupsPlaceApi.js'
import {
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbCarousel,
  mdbCarouselItem,
  mdbContainer,
  mdbSpinner
} from 'mdbvue';

export default {
  name: 'slideShowSection',
  components: {
    mdbContainer,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCarousel,
    mdbCarouselItem,
    mdbBtn,
    mdbSpinner,
    error
  },
  props: {
    group: {
      type: Object,
      default: null
    },
    section: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      carouselData: [],
      error: null,
      imagesLoading: false
    };
  },
  computed: {
    loggedIn: function () {
      return this.$store.state.loggedIn
    },
  },
  mounted() {
    if (!this.group) {
      return
    }
    this.loadContent()
  },
  methods: {
    loadContent: function () {
      this.carouselData = []
      for (let i = 0; i < this.section.data.length; i++) {
        let img = {
          src: this.section.data[i].src, img: true,
          caption: {text: this.section.data[i].caption},
        }
        if (img.caption.text) img.caption.mask = "black-light"
        this.carouselData.push(img)
      }

    },
    reloadImages: function () {
      this.carouselData = []
      this.imagesLoading = true
      api.get("/homepage/slideShowSection/" + this.group.id + "?section=" + this.section.id, {}).then(
        (details) => {
          this.section.data = details.data
          this.loadContent()
          this.imagesLoading = false
        },
        (error) => {
          this.error = error
          this.imagesLoading = false
        })
    },
    navGalleries() {
      this.$router.push(this.group.vanityPath + "/galleries")
    }
  },


}
;
</script>
